// src/App.js
import React from 'react';
import AppRoutes from './routes';
import "./App.css"

const App = () => {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
};

export default App;
